/* TanStack Query hook for the AQ alerts list. */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '../lib/api';

export interface AlertRow {
  alert_id: string;
  device_id: string;
  device_name: string | null;
  alert_type: string;
  severity: 'watch' | 'warn' | 'alarm';
  message: string;
  /** ISO-8601 timestamp. */
  raised_at: string;
  resolved_at: string | null;
  acknowledged_at: string | null;
}

interface UseAlertsArgs {
  /** When true, include alerts already resolved. */
  includeResolved?: boolean;
}

export function useAlerts(args: UseAlertsArgs = {}): UseQueryResult<AlertRow[]> {
  const includeResolved = args.includeResolved ?? false;
  return useQuery<AlertRow[]>({
    queryKey: ['alerts', includeResolved],
    queryFn: () => api.get<AlertRow[]>(`/alerts${includeResolved ? '?include_resolved=1' : ''}`),
  });
}
